#import "../../../../calls/graphql/fragments/phone-integration-fields.graphql"

mutation SyncPastCalls($input: SyncPastCallsInput!) {
    syncPastCalls(input: $input) {
        phoneIntegration {
            ...PhoneIntegrationFields
        }
    }
}
